import React from "react";
import Box from '@mui/material/Box';
import { Avatar, Button, CircularProgress, FormHelperText, Grid, TextField, Typography } from "@mui/material";
import './login.css';
import { styled } from '@mui/material/styles';
import { useLogin } from "./useLogin";
import FullScreenLoader from "../../components/Loading/FullScreenLoading";

// Tipos de retorno del hook

const Login: React.FC = () => {
    const {
        loaderState,
        emptyText,
        emptyUser,
        setLoaderState,
        handleSubmitLogin,
        handleRegister,
        onChangeInput,
    } = useLogin();

    const BootstrapButton = styled(Button)({
        borderRadius: '35px',
        backgroundColor: '#0D85B3',
        height: '4em',
    });

    return (
        <Box
        sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 9,
            marginLeft: 2,
            marginRight: 2,
        }}
        >
        <FullScreenLoader open={loaderState}/>
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            
        </Avatar>
        <Box
            component="form"
            onSubmit={handleSubmitLogin}
            noValidate
            autoComplete="off"
            sx={{ mt: 1 }}
        >
            <TextField
            error={emptyUser}
            margin="normal"
            required
            fullWidth
            id="username"
            label="Usuario"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={onChangeInput}
            />

            <TextField
            required
            error={emptyText}
            margin="normal"
            fullWidth
            name="password"
            label="Clave"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={onChangeInput}
            />

            <FormHelperText
            id="component-helper-text"
            sx={{ color: 'red' }}
            ></FormHelperText>            

           {/*  {loaderState && (
            <div className="d-flex justify-content-center align-items-center">
                <CircularProgress />
            </div>
            )} */}

            <BootstrapButton
            type="submit"
            className="mt-4 w-100"
            variant="contained"
            >
            Iniciar mi sesión
            </BootstrapButton>

           {/*  <div className="d-flex align-items-center w-100 my-3">
            <hr className="flex-grow-1" />
            <span className="mx-2">Accedé con</span>
            <hr className="flex-grow-1" />
            </div>

            <div className="d-flex gap-3 justify-content-center">
            <Button variant="outlined" className="d-flex align-items-center">
                <img src="img/google.png" alt="Google" width={32} />
            </Button>
            <Button variant="outlined" className="d-flex align-items-center">
                <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
                alt="Facebook"
                width={20}
                />
            </Button>
            </div> */}

            <BootstrapButton
            variant="contained"
            className="mt-4 w-100"
            onClick={handleRegister}
            >
            Registrarme
            </BootstrapButton>
        </Box>
        </Box>
    );
};

export default Login;
